import { render, staticRenderFns } from "./login-recovery-password-modal.vue?vue&type=template&id=773857d0&"
import script from "./login-recovery-password-modal.vue?vue&type=script&lang=js&"
export * from "./login-recovery-password-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports